import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

import { StaticProvider, useStatic } from "./context/StaticContext";
import { CssProvider } from "./context/CssContext";
import HomePage from "./pages/HomePage";
import { MaintenanceProvider } from "./context/MaintenanceContext";
import { BonusProvider } from "./context/BonusContext";
import { AdminProvider } from "./context/AdminContextNew";

const App = () => {
  return (
    <Router>
      <StaticProvider>
        <CssProvider>
          <MaintenanceProvider>
            <ReCaptchaWrapper />
          </MaintenanceProvider>
        </CssProvider>
      </StaticProvider>
    </Router>
  );
};

const ReCaptchaWrapper = () => {
  const { title } = useStatic();

  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  return (
    <BonusProvider>
      <Routes>
        <Route
          path="/:userId/*"
          element={
            <AdminProvider>
              <HomePage />
            </AdminProvider>
          }
        />
        <Route
          path="/"
          element={
            <AdminProvider>
              <HomePage />
            </AdminProvider>
          }
        />
      </Routes>
    </BonusProvider>
  );
};

export default App;
